import { useEffect, useState } from 'react';

const LEFT_PHRASES = [
  { text: 'Sania Job Bowl', target: '#home', featured: true, testid: 'rail-left-sania' },
  { text: 'Connecting Talent', target: '#services', testid: 'rail-left-connecting' },
  { text: 'Career Opportunities', target: '#for-job-seekers', testid: 'rail-left-careers' },
];
const RIGHT_PHRASES = [
  { text: 'Your Career, Our Priority', target: '#about', testid: 'rail-right-priority' },
  { text: 'Talent Meets Opportunity', target: '#digital-platforms', testid: 'rail-right-talent' },
  { text: 'Building Better Workplaces', target: '#the-sania-difference', testid: 'rail-right-workplaces' },
];

const scrollToSection = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -116, duration: 1.15 });
  else el.scrollIntoView({ behavior: 'smooth' });
};

/* One group = one seamless half of the loop; gap lives inside the group (pb) so the
   -50% translation lands exactly where the previous group started. */
const RailGroup = ({ items, copy, hidden, active }) => (
  <div className="flex flex-col items-center gap-10 pb-10" aria-hidden={hidden || undefined}>
    {[...items, ...items, ...items].map((item, i) => (
      <button
        key={i}
        type="button"
        onClick={() => scrollToSection(item.target)}
        tabIndex={hidden ? -1 : 0}
        data-testid={`${item.testid}-${copy}-${i}`}
        title={`${item.text} — jump to section`}
        className={`rail-phrase group flex flex-col items-center gap-10 ${item.target === active ? 'rail-phrase--active' : ''}`}
      >
        <span
          className={`rail-phrase-text whitespace-nowrap uppercase [writing-mode:vertical-rl] ${
            item.featured
              ? 'font-display text-[13px] font-extrabold tracking-[0.28em] text-royal'
              : 'font-mono text-[11px] font-semibold tracking-[0.38em] text-royal/60'
          }`}
        >
          {item.text}
        </span>
        <span
          aria-hidden="true"
          className={`h-1.5 w-1.5 rotate-45 rounded-[1px] transition-transform duration-300 group-hover:scale-125 ${
            item.featured ? 'bg-lime' : 'bg-lime/70'
          }`}
        />
      </button>
    ))}
  </div>
);

export default function SideRails() {
  const [active, setActive] = useState('#home');
  useEffect(() => {
    const targets = [...new Set([...LEFT_PHRASES, ...RIGHT_PHRASES].map((p) => p.target))];
    const sections = targets.map((t) => document.querySelector(t)).filter(Boolean);
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) setActive(`#${en.target.id}`);
        });
      },
      { rootMargin: '-35% 0px -55% 0px' },
    );
    sections.forEach((s) => obs.observe(s));
    return () => obs.disconnect();
  }, []);
  return (
    <>
      <aside aria-label="Brand shortcuts" data-testid="side-rail-left" className="side-rail side-rail--left">
        <div className="side-rail-track">
          <RailGroup items={LEFT_PHRASES} copy="a" active={active} />
          <RailGroup items={LEFT_PHRASES} copy="b" hidden active={active} />
        </div>
      </aside>
      <aside aria-label="Brand shortcuts" data-testid="side-rail-right" className="side-rail side-rail--right">
        <div className="side-rail-track">
          <RailGroup items={RIGHT_PHRASES} copy="a" active={active} />
          <RailGroup items={RIGHT_PHRASES} copy="b" hidden active={active} />
        </div>
      </aside>
    </>
  );
}
